import React from 'react'
import * as Toast from '@radix-ui/react-toast'
import { Toasts } from './Toasts'

export function ToastProvider({ children }: React.PropsWithChildren) {
  return (
    <Toast.Provider swipeDirection="up">
      {children}
      <Toasts />
      <Toast.Viewport className="fixed top-0 left-1/2 -translate-x-1/2 flex flex-col p-2.5 gap-2 w-96 max-w-full m-0 list-none outline-hidden z-toast" />
    </Toast.Provider>
  )
}
